<template>
  <div>
    <q-dialog :visible="visible" title="提示" width="500px" @close="onCancel" :innerScroll="false" :loading="loading" @confirm="onConfirm" @cancel="onCancel">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="120px">
        <el-form-item label="请选择导入类型" prop="importType" class="required-label">
          <el-radio-group v-model="form.importType">
            <el-radio :label="1" v-if="isInformationNotMaintained">基础信息导入</el-radio>
            <el-radio :label="0" v-if="isTextNotMaintained">产品文案导入</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </q-dialog>
    <informationImport :visible.sync="isShowInformationImport" v-if="isShowInformationImport" :listNo="listNo" @success="getNewTab"></informationImport>
    <textImport :visible.sync="isShowTextImport" v-if="isShowTextImport" :listNo="listNo" @success="getNewTab"></textImport>
  </div>
</template>

<script>
import informationImport from '../../information-not-maintained/components/importExcel.vue';
import textImport from '../../text-not-maintained/components/importExcel.vue';
export default {
  name: 'RemoveToList',
  components: {
    informationImport,
    textImport,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isInformationNotMaintained: {
      type: Boolean,
      default: false,
    },
    isTextNotMaintained: {
      type: Boolean,
      default: false,
    },
    listNo: [Number, String],
  },
  data() {
    return {
      loading: false,
      loadingBtn: false,
      isShowInformationImport: false,
      isShowTextImport: false,
      form: {
        moveListNo: '',
      },
      rules: {
        importType: [{ required: true, message: '请选择导入类型', trigger: 'change' }],
      },
      listOptions: [],
    };
  },
  computed: {},
  mounted() {},
  methods: {
    onCancel() {
      this.$emit('update:visible', false);
    },
    onConfirm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        if(this.form.importType == 1) {
          this.isShowInformationImport = true
        }else {
          this.isShowTextImport = true
        }
      });
    },
    getNewTab() {
      this.$emit('success');
      this.onCancel();
    }
  },
};
</script>

<style lang="stylus" scoped></style>
